import type { HistoryEntry } from './useRecentlyViewedPages.types'

export const MOCK_HISTORY: HistoryEntry[] = [
  {
    entryType: 'plp',
    title: 'iPad',
    id: '994',
    timestamp: 1789553526,
  },
  {
    entryType: 'plp',
    title: 'MacBook',
    id: '2251',
    timestamp: 1789553525,
  },
  {
    entryType: 'search-query',
    title: 'iPhone 12',
    timestamp: 1789553524,
  },
  {
    entryType: 'search-query',
    title: 'iPhone 13',
    timestamp: 1789553523,
  },
  {
    entryType: 'pdp',
    title: 'iPhone 16 Plus 256GB - Teal - Unlocked',
    timestamp: 1789553522,
    uuid: '2b3c4d0f-eed0-4dd5-b8ca-4d9b30c6badb',
    grade: '12',
    offerType: '0',
  },
  {
    entryType: 'pdp',
    title: 'Iphone 16 512GB - Pink - Unlocked',
    timestamp: 1789553521,
    uuid: '3df81d2b-0834-41b1-ae82-69c58476e16b',
    grade: '12',
    offerType: '0',
  },
  {
    entryType: 'pdp',
    title: 'iPhone 12 128GB - Blue - Unlocked',
    timestamp: 1789553520,
    uuid: 'd5d6c07d-2074-47e0-a8ef-aed925689567',
    grade: '11',
    offerType: '0',
  },
]
